
import { defineComponent } from 'vue'
import { mapGetters, mapState } from 'vuex'
import AsahiTypography from '@/components/library/Typography.vue'
import AsahiButton from '@/components/library/AsahiButton.vue'
import attention from '@/assets/icons/attention.svg'

export default defineComponent({
  name: 'WarningModal',
  components: {
    AsahiTypography,
    AsahiButton
  },
  emits: ['warningAction'],
  props: {
    isCartModal: {
      type: Boolean,
      default: false
    },
    messageHeading: {
      type: String,
      default: ''
    },
    messageSubHeading: {
      type: String,
      default: ''
    },
    messageAdditional: {
      type: String,
      default: ''
    },
    primaryButtonText: {
      type: String,
      default: ''
    },
    secondaryButtonText: {
      type: String,
      default: ''
    },
    selectionType: {
      type: String,
      default: 'shipTo'
    },
    closeModal: {
      type: Function,
      default: () => {
        /* */
      }
    },
    isSapOutage: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      attention
    }
  },
  computed: {
    ...mapState('basket', ['id', 'query', 'items'])
  },
  mounted () {
    if (this.$route.name === 'selectloginview') {
      this.closeModal()
    }
  },
  methods: {
    async removeItemInner (id: string) {
      await this.$store.dispatch('basket/REMOVE_ITEM', { cart_id: this.id, cart_item_id: id }, { root: true })
    },
    async removeAllCartItems () {
      await this.$store.dispatch('basket/REMOVE_ALL_ITEMS', { cart_id: this.id }, { root: true })
      await this.$store.dispatch('basket/FETCH_CART_QUERY', { cart_id: this.id }, { root: true })
    },
    async warningActionUser (action: string) {
      if (action === 'yes' && this.selectionType === 'shipTo') {
        this.$store.commit('basket/SET_LOADING', true, { root: true })
        await this.removeAllCartItems()
        this.$store.commit('basket/SET_LOADING', false, { root: true })
      }
      this.$emit('warningAction', action)
      this.closeModal()
    }
  },
  watch: {
    $route: {
      handler (newValue) {
        if (newValue.name === 'selectloginview') {
          this.closeModal()
        }
      },
      deep: true,
      immediate: true
    }
  }
})
